(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("matrix-mab", [], factory);
	else if(typeof exports === 'object')
		exports["matrix-mab"] = factory();
	else
		root["matrix-mab"] = factory();
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./lib/matrix-mab.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./lib/matrix-mab.js":
/*!***************************!*\
  !*** ./lib/matrix-mab.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// how to rotate image http://www.leptonica.com/rotation.html

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.add_matrices = add_matrices;
exports.pgm_to_matrix = pgm_to_matrix;
exports.normalize_matrix = normalize_matrix;
exports.get_min_and_max_values = get_min_and_max_values;
exports.normalize_int = normalize_int;
exports.normalize_array = normalize_array;
exports.slice2d = slice2d;
exports.random_matrix = random_matrix;
exports.random_array = random_array;
exports.resize = resize;
exports.stretch = stretch;
exports.stretch_row = stretch_row;
exports.stretch_row_sparse = stretch_row_sparse;
exports.enlarge = enlarge;
exports.moving_average = moving_average;
exports.sum_elements = sum_elements;
exports.replace_elements = replace_elements;
exports.is_on_edge = is_on_edge;
exports.are_equal = are_equal;
exports.is_2d_matrix = is_2d_matrix;
function add_matrices(first, second) {
    if (!Array.isArray(first)) {
        throw new Error("first matrix is not an array");
    }

    if (!Array.isArray(second)) {
        throw new Error("second matrix is not an array");
    }

    if (typeof first[0][0] === "undefined") {
        throw new Error("first does not look like a 2d array: must pass 2d arrays to add_matrices");
    }

    if (typeof second[0][0] === "undefined") {
        throw new Error("first does not look like a 2d array: must pass 2d arrays to add_matrices");
    }

    if (first.length !== second.length) {
        throw new Error("the matrices don't have the same height");
    }

    if (first[0].length !== second[0].length) {
        throw new Error("the matrices don't have the same width");
    }

    var height = first.length;
    var width = first[0].length;
    return Array.from(Array(height), function (v, y) {
        return Array.from(Array(width), function (v, x) {
            if (!Number(parseFloat(first[y][x])) === first[y][x]) {
                throw new Error("value not numeric in first matrix" + " at x:" + x + " y: " + y);
            }

            if (!Number(parseFloat(second[y][x])) === second[y][x]) {
                throw new Error("value not numeric in second matrix" + " at x:" + x + " y: " + y);
            }

            return Number(first[y][x]) + Number(second[y][x]);
        });
    });
}

// need to read the image data separately
function pgm_to_matrix(image_data) {

    var lines = image_data.split("\n");
    var type = lines.shift();
    if (type != "P2") {
        throw new Error("File is not PGM");
    }
    lines.shift(); // remove empty lines or comments
    var size = lines.shift().split(" ");

    if (lines[lines.length - 1] == null) {
        lines.pop();
    }

    var map_data = new Array();
    while (lines.length >= size[0]) {
        map_data.push(Array.from(lines.splice(0, size[0]), function (x) {
            return parseInt(x);
        }));
    }

    return map_data;
}

function normalize_matrix(orig, normal_min, normal_max, normalize_function) {
    var _get_min_and_max_valu = get_min_and_max_values(orig),
        min = _get_min_and_max_valu.min,
        max = _get_min_and_max_valu.max;

    if (typeof normalize_function !== "function") {
        normalize_function = function normalize_function(value) {
            return normalize_int(Math.round(Number(value)), min, max, normal_min, normal_max);
        };
    }

    return Array.from(orig, function (row) {
        return Array.from(row, function (item) {
            return normalize_function(item);
        });
    });
}

function get_min_and_max_values(matrix) {
    var min = 0;
    var max = 0;
    var check_row = function check_row(row) {
        row.forEach(function (item) {
            var int_value = Number(item);
            min = min <= int_value ? min : int_value;
            max = max >= int_value ? max : int_value;
        });
    };
    matrix.forEach(check_row);
    return { min: min, max: max };
}

function normalize_int(item, actual_min_value, actual_max_value, normal_min, normal_max) {

    if (normal_min === normal_max) {
        console.log(normal_min, normal_max);
        throw new Error("the normal min and max values are equal");
    }
    // http://mathforum.org/library/drmath/view/60433.html
    // 1 + (x-A)*(10-1)/(B-A)
    return Math.floor(normal_min + (item - actual_min_value) * (normal_max - normal_min) / (actual_max_value - actual_min_value));
}

function normalize_array(input_array, normal_min, normal_max) {

    var actual_max_value = 0;
    var actual_min_value = 0;
    input_array.map(function (item) {
        var item_int = parseInt(item);
        actual_max_value = item_int > actual_max_value ? item_int : actual_max_value;
        actual_min_value = item_int < actual_min_value ? item_int : actual_min_value;
    });

    return input_array.map(function (item) {
        return normalize_int(parseInt(item), actual_min_value, actual_max_value, normal_min, normal_max);
    });
}

function slice2d(original, start_x, end_x, start_y, end_y) {

    if (start_x >= end_x) throw new Error("start_x should be smaller than end_x");
    if (start_y >= end_y) throw new Error("start_y should be smaller than end_y");

    return Array.from(original.slice(start_y, end_y), function (row) {
        return row.slice(start_x, end_x);
    });
}

function random_matrix(width, height) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
        return Math.round(Math.random());
    };

    return Array.from(Array(height), function (v, y) {
        return Array.from(Array(width), function (v, x) {
            return callback(x, y);
        });
    });
}

function random_array(width) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
        return i;
    };

    return Array.from(Array(width), function (v, x) {
        return callback(Math.round(Math.random()));
    });
}

// fill : (x,y) => do_something_based_on_x_and_y_or_just_return_a_value()
// allow_cropping: permit the original to be placed partially outside the new
//    matrix, thus cropping the parts which stay outside
function resize(original, offset, new_size, fill, allow_cropping) {
    if ((typeof new_size === "undefined" ? "undefined" : _typeof(new_size)) !== "object" || parseInt(new_size.x) !== new_size.x || parseInt(new_size.y) !== new_size.y) {
        throw new Error("new_size must be {x: integer, y: integer}");
    }

    if (allow_cropping === false) {
        if (offset.x < 0 || offset.y < 0) {
            throw new Error("cropping is not allowed and the offset coordinates are negative");
        }
        if (original.length > new_size.y || original[0].length > new_size.x) {
            throw new Error("cropping is not allowed and the new size is smaller than the original");
        }

        if (original.length + offset.y > new_size.y || original[0].length + offset.x > new_size.x) {
            throw new Error("cropping is not allowed and the offset" + " pushes the original outside the new size");
        }
    }

    return Array.from(Array(new_size.y), function (y_value, y) {
        return Array.from(Array(new_size.x), function (x_value, x) {
            if (original[y + offset.y] !== undefined && original[y + offset.y][x + offset.x] !== undefined) {
                return original[y + offset.y][x + offset.x];
            }
            return fill(x, y);
        });
    });
}

function stretch(orig, new_width, new_height) {
    var height = orig.length;
    var spacing = (new_height - 1) / (height - 1);
    var stretched_coordinates = Array.from(Array(height), function (value, i) {
        return i * spacing;
    });
    // deal with floating point weirdnesses, make sure the last value is what
    //   it should be; problems happen when the initial matrix has one size 40
    stretched_coordinates[stretched_coordinates.length - 1] = new_height - 1;

    var orig_coordinates = 0;
    var next_coordinates = stretched_coordinates[orig_coordinates];
    // let prev_coordinates = 0
    var sparse = Array.from(Array(new_height), function (undef, i) {
        if (next_coordinates - i <= next_coordinates % 1 // less than the fractional part
        ) {
                var stretched_row = stretch_row(orig[orig_coordinates], new_width);
                // prev_coordinates = next_coordinates
                orig_coordinates += 1;
                next_coordinates = stretched_coordinates[orig_coordinates];
                return stretched_row;
            } else {
            return Array.from(Array(new_width), function () {
                return null;
            });
        }
    });

    var stretched = Array.from(sparse, function (row, y) {
        return Array.from(row, function (cell, x) {
            if (cell === null) {
                return evaluate_neighbours(sparse, x, y);
            } else {
                return cell;
            }
        });
    });

    return stretched;
}

function evaluate_neighbours(matrix, x, y) {

    if (x !== parseInt(x)) {
        throw new Error("x is not an integer");
    }
    if (y !== parseInt(y)) {
        throw new Error("y is not an integer");
    }

    var top_value = 0;
    var bottom_value = 0;
    // we're in the top or bottom row:
    //   that is wrong, the algorithm keeps the original
    //   data for the borders on the new borders so it should not happen
    if (typeof matrix[y - 1] === "undefined") {
        console.error({ "length": matrix.length, "x": x, "y": y });
        // console.error(matrix)
        throw new Error("we're in the top row - , there should be no undefined value here");
    }

    if (typeof matrix[y + 1] === "undefined") {
        console.error({ "length": matrix.length, "x": x, "y": y });
        // console.error(matrix)
        throw new Error("we're in the top row +, there should be no undefined value here");
    }

    var top = 1; // distance to the first not null row
    while (top < matrix.length) {
        if (matrix[y - top][x] !== null) {
            top_value = Number(matrix[y - top][x]);
            break;
        }
        top += 1;
    }

    var bottom = 1;
    while (bottom < matrix.length) {
        if (matrix[y + bottom][x] !== null) {
            bottom_value = Number(matrix[y + bottom][x]);
            if (isNaN(bottom_value)) {
                console.error({
                    y: y,
                    bottom: bottom,
                    x: x,
                    wrong: matrix[y + bottom][x],
                    length: matrix[0].length,
                    height: matrix.length
                });
                throw new Error("bottom value isNaN, something is very wrong");
            }
            break;
        }
        bottom += 1;
    }

    var slope = (bottom_value - top_value) / (top + bottom);
    var value = top_value + slope * top;
    if (isNaN(value)) {
        console.error({
            top_value: top_value,
            top: top,
            bottom: bottom,
            bottom_value: bottom_value,
            slope: slope,
            value: value
        });
        throw new Error("got a NaN result, something is very wrong");
    }
    return value;
}

function stretch_row(orig, new_size) {

    var spacing = (new_size - 1) / (orig.length - 1);
    var stretched_coordinates = Array.from(Array(orig.length), function (value, i) {
        return i * spacing;
    });

    // deal with floating point weirdnesses, make sure the last value is what
    //   it should be; problems happen when the initial matrix has one size 40
    stretched_coordinates[stretched_coordinates.length - 1] = new_size - 1;

    var orig_coordinates = 0;
    var next_coordinates = stretched_coordinates[orig_coordinates];
    var prev_coordinates = 0;
    var stretched = Array.from(Array(new_size), function (undef, i) {

        if (
        // less than the fractional part
        next_coordinates - i <= next_coordinates % 1) {
            var value = orig[orig_coordinates];
            prev_coordinates = next_coordinates;
            orig_coordinates += 1;
            next_coordinates = stretched_coordinates[orig_coordinates];
            return value;
        } else {
            var slope = Number(orig[orig_coordinates] - orig[orig_coordinates - 1]) / Number(next_coordinates - prev_coordinates);

            if (isNaN(slope)) {
                console.error("xxx slope is NaN", i, orig_coordinates, orig);
                throw new Error("something very wrong: slope is NaN");
            }

            var _value = Number(orig[orig_coordinates - 1]) + Number(slope * (i - prev_coordinates));

            if (isNaN(_value)) {
                console.error("yyy isNaN", i, slope, orig[orig_coordinates - 1], prev_coordinates, orig);
                throw new Error("something very wrong: value is NaN");
            }
            return _value;
        }
    });

    return stretched;
}

function stretch_row_sparse(orig, new_size) {

    var spacing = (new_size - 1) / (orig.length - 1);
    var stretched_coordinates = Array.from(Array(orig.length), function (value, i) {
        return i * spacing;
    });

    // deal with floating point weirdnesses, make sure the last value is what
    //   it should be; problems happen when the initial matrix has one size 40
    stretched_coordinates[stretched_coordinates.length - 1] = new_size - 1;

    var orig_coordinates = 0;
    var next_coordinates = stretched_coordinates[orig_coordinates];
    var prev_coordinates = 0;
    var stretched = Array.from(Array(new_size), function (undef, i) {

        if (
        // less than the fractional part
        next_coordinates - i <= next_coordinates % 1) {
            var value = orig[orig_coordinates];
            prev_coordinates = next_coordinates;
            orig_coordinates += 1;
            next_coordinates = stretched_coordinates[orig_coordinates];
            return value;
        } else {
            return null;
        }
    });

    return stretched;
}

function enlarge(orig, new_width, new_height) {
    var height = orig.length;
    var spacing = (new_height - 1) / (height - 1);
    var stretched_coordinates = Array.from(Array(height), function (value, i) {
        return i * spacing;
    });

    var orig_coordinates = 0;
    var next_coordinates = stretched_coordinates[orig_coordinates];
    // let prev_coordinates = 0
    var sparse = Array.from(Array(new_height), function (undef, i) {
        if (next_coordinates - i <= next_coordinates % 1 // less than the fractional part
        ) {
                var stretched_row = stretch_row_sparse(orig[orig_coordinates], new_width);
                // prev_coordinates = next_coordinates
                orig_coordinates += 1;
                next_coordinates = stretched_coordinates[orig_coordinates];
                return stretched_row;
            } else {
            return Array.from(Array(new_width), function () {
                return null;
            });
        }
    });

    var stretched = Array.from(sparse, function (row, y) {
        return Array.from(sparse[y], function (cell, x) {
            if (cell === null) {
                return evaluate_neighbours_sparse(sparse, x, y);
            } else {
                return cell;
            }
        });
    });

    return stretched;
}

function moving_average(matrix, distance) {
    if (distance !== parseInt(distance)) {
        throw new Error("distance " + distance + " is not an integer");
    }

    if (distance <= 0) {
        throw new Error("distance should be a positive integer");
    }

    return Array.from(matrix, function (row, y) {
        return Array.from(row, function (item, x) {
            var slice = resize(matrix, { "x": x - distance, "y": y - distance }, { "x": 2 * distance + 1, "y": 2 * distance + 1 }, function () {
                return 0;
            }, // fill the extra cells with 0s,
            true // allow cropping
            );
            var cells_count = slice.length * slice.length;
            return sum_elements(slice) / cells_count;
        });
    });
}

function sum_elements(matrix) {
    var result = 0;
    matrix.forEach(function (row) {
        result += row.reduce(function (row_sum, cell) {
            // can't find a reliable way to determine if a variable
            // is numeric, so I'm sticking with the strict option
            // which will throw errors even for "1234"
            if (isNaN(cell)) {
                throw new Error("cell is NaN");
            }
            if (Number(cell) !== cell) {
                throw new Error("element " + cell + " is not a number");
            }
            return Number(row_sum) + Number(cell);
        });
    });
    return result;
}

function replace_elements(matrix) {
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
        return i < 0;
    };
    var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (i) {
        return Math.abs(i);
    };


    return Array.from(matrix, function (row, y) {
        return Array.from(row, function (cell, x) {
            if (filter(cell)) {
                return transform(cell);
            }
            return cell;
        });
    });
}

function is_on_edge(width, height, x, y, distance) {
    if (x < distance || y < distance || x >= width - distance || y >= height - distance) {
        return true;
    }
    return false;
}

function are_equal(first, second) {
    if (!is_2d_matrix(first)) {
        throw new Error("first parameter is not a 2d array");
    }

    if (!is_2d_matrix(second)) {
        throw new Error("second parameter is not a 2d array");
    }

    if (first.length !== second.length) {
        return false;
    }

    if (first[0].length !== second[0].length) {
        return false;
    }

    for (var y = 0; y < first.length; y++) {
        for (var x = 0; x < first[0].length; x++) {
            if (first[y][x] !== second[y][x]) {
                return false;
            }
        }
    }
    return true;
}

function is_2d_matrix(matrix) {
    if (matrix[0] === undefined) {
        return false;
    }
    if (matrix[0].constructor !== Array) {
        return false;
    }
    return true;
}

/***/ })

/******/ });
});
//# sourceMappingURL=matrix-mab.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/matrix-mab/dist/matrix-mab.js
// module id = 71
// module chunks = 0